import { ExternalLinkIcon } from "@theprelude/ds";

export function ExternalLink({ href }: { href: string }) {
  return (
    <a
      target="_blank"
      href={href}
      rel="noreferrer"
      className="inline-flex text-secondary-foreground hover:text-primary-foreground"
    >
      <ExternalLinkIcon className="size-4" />
    </a>
  );
}
